<template>
  <div id="app">
    <nav class="nav">
      <router-link to="/" class="nav-link">Тренажёр</router-link>
      <router-link to="/stats" class="nav-link">Статистика</router-link>
    </nav>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background: #f0f4f8;
  color: #2d3748;
}

#app {
  max-width: 600px;
  margin: 0 auto;
  padding: 16px;
  min-height: 100vh;
}

.nav {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
}

.nav-link {
  flex: 1;
  padding: 12px;
  font-size: 16px;
  text-align: center;
  text-decoration: none;
  border-radius: 8px;
  background: #e2e8f0;
  color: #4a5568;
  transition: all 0.2s;
}

.nav-link:hover {
  background: #cbd5e0;
}

.nav-link.router-link-exact-active {
  background: #4299e1;
  color: #fff;
  font-weight: 600;
}
</style>
